import React from 'react';
import PropTypes from 'prop-types';

const TextCalculatedFor = ({ data }) => {
  let displayText = "Kröfuhafa";
  if (data === 1)
  {
    displayText = "Lögfræðing";
  }
  return (
    <span>{displayText}</span>
  );
};

TextCalculatedFor.propTypes = {
  data: PropTypes.number,
};

export default TextCalculatedFor;


